import type {IntegrationWidgetStatus} from 'shells/integration-widget/integration-widget';

import type {ThreadType} from 'nutshell-graphql-types';

export function getMessageTypeString(messageType: ThreadType): string {
    switch (messageType) {
        case 'SMS':
            return 'SMS';
        case 'MESSENGER':
            return 'Facebook and Instagram';
        case 'WHATSAPP':
            return 'WhatsApp';
        case 'EMAIL':
            return 'Email';
        default:
            return messageType;
    }
}

export const getIntegrationWidgetStatusEnum = (
    isEnabled: boolean,
    isToggling: boolean
): IntegrationWidgetStatus => {
    switch (true) {
        case isEnabled && isToggling:
            return 'disabling';
        case isEnabled && !isToggling:
            return 'enabled';
        case !isEnabled && isToggling:
            return 'enabling';
        default:
            return 'disabled';
    }
};
